import { MostPopularType, Item } from './mostPopularType';
import { SearchType, SearchItem } from './searchType';
import { SingleVideoType, SingleVideoItem } from './singleVideoType';

export type FormCardData = {
  name: string;
  date: string;
  city: string;
  gender: string;
  fileName: string;
};

export type FormCardDataType = {
  formCardsData: FormCardData[];
};

export type fetchRequestType = {
  response: MostPopularType | SearchType | SingleVideoType | null;
  error: boolean;
};

export enum SearchSettingsEnum {
  regionCode = 'regionCode',
  videoOrder = 'videoOrder',
  videoType = 'videoType',
  maxResults = 'maxResults',
}

export enum RegionCodeEnum {
  US = 'US',
  GB = 'GB',
  RU = 'RU',
  GE = 'GE',
}

export enum VideoOrderEnum {
  viewCount = 'viewCount',
  relevance = 'relevance',
  title = 'title',
  rating = 'rating',
}

export enum VideoTypeEnum {
  video = 'video',
  channel = 'channel',
  playlist = 'playlist',
}

export enum MaxResultsEnum {
  first = '12',
  two = '24',
  three = '36',
}

export type SearchBarState = {
  videoOrder?: VideoOrderEnum;
  regionCode: RegionCodeEnum;
  videoType?: VideoTypeEnum;
  maxResults: MaxResultsEnum;
};

export type HomepageState = {
  isLoaded: boolean;
  cards: Item[] | SearchItem[] | [] | null;
  hasError: boolean;
  prevPageToken: string | null;
  nextPageToken: string | null;
  totalResults: number | null;
  resultsPerPage: number | null;
};

export type ModalState = {
  isModalLoaded: boolean;
  modalCard: SingleVideoItem | [] | null;
  hasModalError: boolean;
};

export type GlobalAppState = {
  search: string;
  showModal: boolean;
  pageNumber: number;
  currPageToken: string | null;
  homePageState: HomepageState;
  searchBarState: SearchBarState;
  modalState: ModalState;
};

export type PayloadPaginationType = {
  pageNumber: number;
  pageToken: string | null;
};
